// API URLs

import {BASE_URL} from "../env.json"


export const PRIVACY_POLICY: string = "https://everaccountable.com/legal/#privacy/";
export const SAVE_RESPONSE: string = BASE_URL + "recovery2/save-response/";
export const QUIZ_RESPONSE: string = BASE_URL + "recovery2/quiz-response/";
export const SUPPORTING_CONTENT: string = BASE_URL + "recovery2/support-content/";
export const COMPLETE_PROGRAM: string = BASE_URL + "recovery2/complete-program/";
export const CHECK_AP: string = BASE_URL + "recovery2/check-ap/";